const getTimerWorker = () => {
    return new Worker(new URL('utils/Timer/TimerWorker.worker.ts', import.meta.url));
}

export default getTimerWorker;